import resume from "../assets/pdf/resume.pdf";

export const headerData = {
  name: "Sangam Choudhary",
  title: "Hello! I'am",
  desciption:
    "The more you sweat in peace the less you bleed in war",
  image: "https://avatars.githubusercontent.com/u/80592720?v=4",
  resumePdf: resume,
};
